import React from 'react';

import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const Stability = ({ listStability }) => {
    return (
        <div className="stability-pochtabank">
            <FullWrapper>
                <div className="stability-pochtabank__Title">
                    Отказоустойчивость и&nbsp;масштабируемость сайта
                </div>

                <div className="stability-pochtabank__Inner">
                    <div className="stability-pochtabank__Left">
                        <div>
                            Сайт банка&nbsp;&mdash; это высоконагруженный проект с&nbsp;ежемесячным
                            трафиком около 5&nbsp;млн пользователей. Поэтому основным требованием
                            к&nbsp;инфраструктуре проекта была отказоустойчивость. При создании
                            новой версии сайта Почта Банка решали задачу перехода на&nbsp;облачную
                            архитектуру.
                        </div>
                        <div>
                            Команда devops-инженеров &laquo;Вебпрактик&raquo; помогла развернуть
                            отказоустойчивое решение в&nbsp;Яндекс.Облаке, которое стало практически
                            стандартом для российского финансового сектора.
                        </div>
                        <div>
                            Задачи масштабирования и&nbsp;отказоустойчивости решили посредством
                            построения кластера на&nbsp;базе Kubernetes. Это система с&nbsp;открытым
                            исходным кодом для автоматизации развертывания, масштабирования
                            и&nbsp;управления контейнерными приложениями. Как PHP-приложение
                            на&nbsp;примере Bitrix Framework можно разместить в&nbsp;Kubernetes,
                            рассказываем в&nbsp;докладе{' '}
                            <a
                                href="https://www.youtube.com/watch?v=XmzQtKwieDM&t=1s"
                                target="_blank"
                                rel="noreferrer"
                            >
                                на&nbsp;PHP митапе.
                            </a>
                        </div>
                    </div>
                    <div className="stability-pochtabank__Right">
                        <div className="stability-pochtabank__Description">
                            <img
                                src="/images/svg/new-pochtabank/youtube.svg"
                                alt="github"
                                className="stability-pochtabank__Icon"
                            />
                            <div className="stability-pochtabank__Top">
                                Смотрите{' '}
                                <a
                                    href="https://www.youtube.com/watch?v=XmzQtKwieDM&t=1s"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    запись нашего доклада
                                </a>{' '}
                                на&nbsp;rndphp о&nbsp;реализации архитектуры данного проекта
                            </div>
                        </div>
                    </div>
                </div>

                <div className="stability-pochtabank__Image">
                    <img src="/images/pic/new-pochtabank/stability.jpg" alt="stability" />
                </div>

                <div className="stability-pochtabank__Wrapper">
                    <div className="stability-pochtabank__Left">
                        Для повышения отказоустойчивости проекта внедрили умный кеширующий слой
                        Varnish. Это помогло снизить нагрузку на&nbsp;основной сайт, уменьшить объем
                        используемых ресурсов и&nbsp;получить экономический профит.
                    </div>
                    <div className="stability-pochtabank__Next">
                        <div className="stability-pochtabank__Program">
                            <div>Система кеширования</div>
                            <div className="stability-pochtabank__Bottom">
                                <img
                                    src="/images/svg/new-pochtabank/varnish.svg"
                                    alt="img"
                                    className="stability-pochtabank__Img"
                                />
                                <div className="stability-pochtabank__Text">Varnish Cache</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="stability-pochtabank__Last">
                    <div className="stability-pochtabank__Left">
                        <div>
                            Для решения задач управления трафиком (таймауты, повторные попытки,
                            балансировка нагрузки) и&nbsp;улучшенной наблюдаемости (трассировка,
                            мониторинг, логирование) в&nbsp;качестве Ingress контроллера внедрили
                            Istio.
                        </div>
                        <div>
                            В&nbsp;качестве мониторинга использовали Prometheus для сбора метрик
                            и&nbsp;Grafana для удобной визуализации и&nbsp;построения дашбордов.
                            Логирование закрыли стандартным ELK стеком. Для мониторинга исключений
                            на&nbsp;frontend и&nbsp;backend мы&nbsp;внедрили Sentry.
                        </div>
                        <div>
                            Для облегчения работы команды с&nbsp;релизами использовали ChatOps
                            на&nbsp;базе Telegram. Можно выполнить разные сценарии через команды,
                            не&nbsp;подключаясь к&nbsp;кластеру. Туда&nbsp;же мы&nbsp;получаем все
                            алерты от&nbsp;prometheus и&nbsp;sentry.
                        </div>
                        <div>
                            Нагрузочное тестирование подтвердило достижение целевых показателей
                            скорости ответа при целевом количестве посещений с&nbsp;запасом. Также
                            тестировали стрессовые сценарии масштабирования кластера с&nbsp;помощью
                            настроенных HPA политик. Это важно в&nbsp;период проведения рекламных
                            акций, когда возникают пиковые нагрузки. Настроенные HPA политики
                            позволяют схлопываться кластеру до&nbsp;минимальных ресурсов
                            в&nbsp;облаке, потребляя наименьшее количество ресурсов.
                        </div>
                    </div>
                    <div className="stability-pochtabank__Next">
                        <div className="stability-pochtabank__Program">
                            <div>Мониторинг</div>
                            <div className="stability-pochtabank__Items">
                                {listStability.map((item, idx) => (
                                    <div className="stability-pochtabank__Bottom" key={idx}>
                                        {item.img && (
                                            <img
                                                src={item.img}
                                                alt="img"
                                                className="stability-pochtabank__Img"
                                            />
                                        )}
                                        <div className="stability-pochtabank__Text">
                                            {item.text}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Stability;
